// coreModal.js
import { gsap } from "../../utils/gsapSetup.js";

export function createModal({ modifier }) {
  if (document.getElementById("modal")) return null;

  const modal = document.createElement("div");
  modal.id = "modal";
  modal.className = `l-modal ${modifier}`;

  const container = document.createElement("div");
  container.className = "l-modal__container";

  const body = document.createElement("div");
  body.className = `l-modal__body ${modifier}__body`;

  const closeBtn = document.createElement("button");
  closeBtn.className = "l-modal__close";
  closeBtn.type = "button";
  closeBtn.innerHTML = `<span class="l-modal__close--icon"></span>`;

  body.appendChild(closeBtn);
  container.appendChild(body);
  modal.appendChild(container);
  document.body.appendChild(modal);

  // scroll lock
  const scrollBarWidth =
  window.innerWidth - document.documentElement.clientWidth;
  document.body.style.overflow = "hidden";
  document.body.style.paddingRight = `${scrollBarWidth}px`;
  document.body.classList.add("is-open--modal");

  // animation
  gsap.set(modal, { autoAlpha: 0 });
  gsap.set(body, { autoAlpha: 0, scale: 0.9 });
  // gsap.set(body, { scale: 0.9 });
  const openTl = gsap
    .timeline()
    .set(modal, { display: "flex" })
    .to(modal, { autoAlpha: 1, duration: 0.3 })
    .to(body, { autoAlpha: 1, scale: 1, duration: 0.3 }, "-=0.15");

  function close() {
    // 多重実行防止
    if (gsap.isTweening(modal)) return;

    gsap
      .timeline({
        onComplete: () => {
          modal.remove();
          document.body.style.overflow = "";
          document.body.style.paddingRight = "";
          document.body.classList.remove("is-open--modal");
        },
      })
      .to(
        modal,
        {
          autoAlpha: 0,
          duration: 0.3,
          ease: "power2.in",
        },
        "-=0.1"
      )
      .to(
        body, {
          autoAlpha: 0,
          scale: 0.9,
          duration: 0.2,
          ease: "power2.in",
        },"-=0.1"
      );
    // modal.remove();
    // document.body.style.overflow = "";
    // document.body.style.paddingRight = "";
  }

  function onKeyDown(e) {
    if (e.key === "Escape") close();
  }
  document.addEventListener("keydown", onKeyDown);

  closeBtn.addEventListener("click", close);
  container.addEventListener("click", close);
  body.addEventListener("click", (e) => {
    // if (e.target === modal) close();
    e.stopPropagation();
  });

  return { modal, body, close, openTl };
}
